const domainGuideLang = {
  Status: {
    ACTIVE: {
      Title: 'ACTIVE',
      ColumnTitle: 'Active',
    },
    INACTIVE: {
      Title: 'INACTIVE',
      ColumnTitle: 'Inactive',
    },
    DELETED: {
      Title: 'DELETED',
      ColumnTitle: 'Deleted',
    },
  },
  Detail: {
    EmptyValue: '-',
    NotFound: 'Domain guide not found',
    Fields: {
      DomainGuideId: 'Domain guide ID',
      Description: 'Description',
      Status: 'Status',
      TeamName: 'Assigned team',
      CreatedBy: 'Created by',
      CreatedAt: 'Created',
      UpdatedAt: 'Updated',
    },
    Assignment: {
      Title: 'Assignments',
      TeamPlaceholder: 'Select a team',
      SlackIdLabel: 'Slack IDs',
      SlackIdPlaceholder: 'Select a Slack ID',
      AddSlackId: 'Add Slack ID',
      NoSlackIds: 'No Slack IDs',
    },
    TeamOptions: {
      Sales: 'Sales',
      Recruiting: 'Recruiting',
      Operations: 'Operations',
    },
    SlackIdOptions: {
      Blake: 'Blake',
      Bianca: 'Bianca',
      Daniel: 'Daniel',
      Patrick: 'Patrick',
    },
    RawDomainGuide: {
      Title: 'Raw Domain Guide',
    },
  },
};

export default domainGuideLang;
